// removed by extract-text-webpack-plugin
module.exports = {"notification":"notification__lWwO4"};


//////////////////
// WEBPACK FOOTER
// ./components/communication/notification/style.scss
// module id = jzqA
// module chunks = 27